export default {
  key: 'folderColoursEnabled',
  type: 'boolean',
  label: 'Folder colours',
  description: 'Lets you pick a colour for each folder in My Files. People you share a folder with see its colour once they turn this on too.',
  default: false,
  group: 'My Files',
  featureFlag: 'MARK-25-folder-colours',
}
